import { useAppContext } from "./useAppContext";

export const useClient = () => {
	const { client } = useAppContext();

	return client;
};
